import { render, staticRenderFns } from "./CareerAiMessageList.vue?vue&type=template&id=e458213c&scoped=true"
import script from "./CareerAiMessageList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerAiMessageList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/career-ai/career-ai-messages.scss?vue&type=style&index=0&id=e458213c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e458213c",
  null
  
)

export default component.exports